// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-contact-js": function componentSrcPagesContactJs() {
    return import("./../../src/pages/contact.js"
    /* webpackChunkName: "component---src-pages-contact-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-lightbox-js": function componentSrcPagesLightboxJs() {
    return import("./../../src/pages/lightbox.js"
    /* webpackChunkName: "component---src-pages-lightbox-js" */
    );
  },
  "component---src-pages-production-js": function componentSrcPagesProductionJs() {
    return import("./../../src/pages/production.js"
    /* webpackChunkName: "component---src-pages-production-js" */
    );
  },
  "component---src-pages-sustainability-policy-js": function componentSrcPagesSustainabilityPolicyJs() {
    return import("./../../src/pages/sustainability-policy.js"
    /* webpackChunkName: "component---src-pages-sustainability-policy-js" */
    );
  },
  "component---src-templates-article-js": function componentSrcTemplatesArticleJs() {
    return import("./../../src/templates/article.js"
    /* webpackChunkName: "component---src-templates-article-js" */
    );
  },
  "component---src-templates-artist-js": function componentSrcTemplatesArtistJs() {
    return import("./../../src/templates/artist.js"
    /* webpackChunkName: "component---src-templates-artist-js" */
    );
  },
  "component---src-templates-legal-js": function componentSrcTemplatesLegalJs() {
    return import("./../../src/templates/legal.js"
    /* webpackChunkName: "component---src-templates-legal-js" */
    );
  },
  "component---src-templates-news-js": function componentSrcTemplatesNewsJs() {
    return import("./../../src/templates/news.js"
    /* webpackChunkName: "component---src-templates-news-js" */
    );
  },
  "component---src-templates-project-js": function componentSrcTemplatesProjectJs() {
    return import("./../../src/templates/project.js"
    /* webpackChunkName: "component---src-templates-project-js" */
    );
  }
};